import { useState, useEffect, useContext } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button,
} from "@mui/material";
import { reducerContext } from "../../../../contextApi's/contextApi's";

import FaqCategory from "./FaqCategory";
import Faqs from "./Faqs";
import FaqTag from "./FaqTag";
import TagMapping from "./TagMapping";

import snackError from "../../../../helpers/snackError";
import { httpRequest } from "../../../../ui-utils/api";
import { backendHosts, apiUrl } from "../../../../ui-utils/apiConfig";
import axios from "axios";

const FaqDialog = ({ open, onClose }) => {
    const { dispatch } = useContext(reducerContext)

    useEffect(() => {
        (async () => {
            try {


                 const result= await axios.get(`${backendHosts.ADMIN}${apiUrl.faqCategories}`)
                // const result = await httpRequest({
                //     endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.faqCategories}`,
                //     method: "get",
                //     instance: "instanceOne",
                // })

                console.log("result",result.data)

                if (result.data?.status == 200) {
                    dispatch({
                        type: 'SET_FAQ_CATEGORIES',
                        payload: result.data?.categories
                    })

                }
            } catch (error) {
                console.log("Error while fetching categories list API", error)
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: error.error })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            }
        })()

    }, []);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
            <DialogTitle>Create New FAQ</DialogTitle>
            <DialogContent dividers>
                <FaqCategory />
                <FaqTag />
                <Faqs />
                <TagMapping />

            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
};

export default FaqDialog;
